import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import isBetween from 'dayjs/plugin/isBetween';
import utc from 'dayjs/plugin/utc';
import localeData from 'dayjs/plugin/localeData';
import isoWeek from 'dayjs/plugin/isoWeek';
import minMax from 'dayjs/plugin/minMax';
import 'dayjs/locale/en';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.locale('en');

dayjs.extend(quarterOfYear);
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);
dayjs.extend(utc);
dayjs.extend(localeData);
dayjs.extend(isoWeek);
dayjs.extend(minMax);
dayjs.extend(updateLocale);

dayjs.updateLocale('en', {
    weekStart: 1,
});

export default dayjs;
